import { useState } from "react";
import { Hash, Loader2, Plus } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import type { ChannelState } from "@/lib/concord/editions";

export function ChannelsAdmin({
  channels,
  onCreate,
  creating,
}: {
  channels: ChannelState[];
  onCreate: (name: string) => void;
  creating: boolean;
}) {
  const [name, setName] = useState("");

  return (
    <Card>
      <CardHeader>
        <CardTitle className="font-display text-xl">Channels</CardTitle>
        <CardDescription>
          Public channels are readable by every member (their keys derive from
          the community root). Private channels are coming soon.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <ul className="space-y-2">
          {channels.map((c) => (
            <li
              key={c.id}
              className="flex items-center gap-2 rounded-lg border bg-card px-3 py-2.5 text-sm"
            >
              <Hash className="size-4 text-muted-foreground" />
              <span className="font-medium">{c.name}</span>
              {c.deleted && (
                <span className="text-xs text-muted-foreground">(deleted)</span>
              )}
            </li>
          ))}
        </ul>
        <form
          className="flex gap-2"
          onSubmit={(e) => {
            e.preventDefault();
            const n = name.trim().toLowerCase().replace(/\s+/g, "-");
            if (!n || creating) return;
            onCreate(n);
            setName("");
          }}
        >
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="new-channel-name"
            maxLength={64}
            aria-label="New channel name"
          />
          <Button type="submit" disabled={!name.trim() || creating}>
            {creating ? <Loader2 className="size-4 animate-spin" /> : <Plus className="size-4" />}
            Add
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}
